import { ChannelkartNetworkGet, ChannelkartNetworkPut } from "../../services/networkService";
// import { getLob, } from "../../services/authenticationService";
// import { downloadReport, getReport, task } from "../../services/reportService";

export async function getRateMasterData(): Promise<any[]>{
    try {
        const designation = JSON.parse(localStorage.authContext).user.designation[0];
        let url="";
        if(designation ==='expenseapprover1') {
            url = "/v1/query/RateMasterPendingQuery"
        }
        else if(designation ==='expenseapprover2')  {
            url = "/v1/query/RateMasterA1ApprovedQuery"
        }
      const res = 
      await ChannelkartNetworkGet(url);
      const data = res?.data?.features || [];
        return data.map((item:any, index:number) => ({ ...item, id: index + 1 }));

    } catch (error) {
      console.log(error);
      return [];
    }
}

export const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

export async function approveRejectRateMaster(statusToUpdate: string, obj: any, reason: string): Promise<any> {

    const reqBody = {
        statusToUpdate: statusToUpdate,
        designation: obj.designation,
        from_date: obj.from_date,
        approval_remarks: reason,
        approved_by: JSON.parse(localStorage.authContext).user.loginId,
        existingStatus: obj.status
    };

    try{
        const res = await ChannelkartNetworkPut("/v1/ratemaster/statusUpdate", reqBody);
        if (res.status === 200 || res.status === 201) {
            return "success";
        }
        else {
            return "An error occurred while updating the status. Please try again.";
        }
    
    }
    catch(e){
        console.error("Failed to update status:", e)
        return "An error occurred while updating the status. Please try again."
    }
}